import { render, staticRenderFns } from "./tournamentFullStats.vue?vue&type=template&id=3e9538c2&scoped=true"
import script from "./tournamentFullStats.vue?vue&type=script&lang=js"
export * from "./tournamentFullStats.vue?vue&type=script&lang=js"
import style0 from "./tournamentFullStats.vue?vue&type=style&index=0&id=3e9538c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9538c2",
  null
  
)

export default component.exports